<div *ngIf="screenInfo$ | async as screen" style="display: flex; flex-direction: column; height: 100%">
    <div *ngIf="isLoading"
        style="flex: 1 0 100%; min-height: 0; display: flex; flex-direction: column; justify-content: space-between;">
        <div style="flex: 1; display: flex; align-items: center; justify-content: center;">
            <sh-spinner id="funcloc-details-spinner-1" site="s"></sh-spinner>
        </div>
    </div>
    <div *ngIf="!isLoading && site" style="flex: 1; min-height: 0;">
        <p-table [size]="'small'" #table [value]="site" [scrollable]="true" scrollHeight="flex" [customSort]="true"
            (sortFunction)="customSort($event)" [sortField]="'serial_number'" [sortOrder]="1">

            <!-- Tools -->
            <ng-template #caption style="border: none;">
                <div style="display: flex; align-items: center; gap: 8px;">
                    <sh-text id="funcloc-details-text-2" size="title-1" style="flex: 1 1 40%;">{{ 'funclocDetails.title' | transloco }}</sh-text>

                    <div class="table-tools" style="flex: 1 1 60%; gap: 8px; align-items: center;">
                        <sh-dropdown id="funcloc-details-dropdown-3" no-border condensed style="min-width: 100px; max-width: 140px;">
                            <sh-menu-item id="funcloc-details-menu-item-last-7-days" (click)="changeRange(7)" [attr.label]="'funclocDetails.range.last7Days' | transloco"
                                [active]="selectedRange === 7"></sh-menu-item>
                            <sh-menu-item id="funcloc-details-menu-item-last-14-days" (click)="changeRange(14)" [attr.label]="'funclocDetails.range.last14Days' | transloco"
                                [active]="selectedRange === 14"></sh-menu-item>
                            <sh-menu-item id="funcloc-details-menu-item-last-30-days" (click)="changeRange(30)" [attr.label]="'funclocDetails.range.last30Days' | transloco"
                                [active]="selectedRange === 30"></sh-menu-item>
                        </sh-dropdown>

                        <sh-divider id="funcloc-details-divider-7" spacing='s' style="height: 30px;" vertical></sh-divider>

                        <sh-icon id="funcloc-details-icon-8" button icon='refresh' size="s" (click)="refresh()"></sh-icon>
                        <sh-icon id="funcloc-details-icon-9" *ngIf="workareaSize !== 'fullscreen'" size="xs" [icon]="workareaSize === 'medium' ? 'arrow-face-up-l' : 'arrow-face-down-l'"
                            button (click)="onMaximize()" [tabindex]="workareaSize === 'small' ? -1 : 0"></sh-icon>
                        <sh-icon id="funcloc-details-icon-expand" size="s" [icon]="workareaSize === 'fullscreen' ? 'split-vertically' : 'maximize'" button (click)="onExpand($event)"
                            [tabindex]="workareaSize === 'small' ? -1 : 0"></sh-icon>
                        <sh-icon id="funcloc-details-icon-cancel" icon="cancel" size="s" button (click)="onMinimize()"
                            [tabindex]="workareaSize === 'small' ? -1 : 0"></sh-icon>
                    </div>
                </div>



            </ng-template>

            <!-- Header -->
            <ng-template #header>
                <tr>
                    <th pSortableColumn="serial_number" style="min-width:175px;" pFrozenColumn>
                        <div style="display: flex; gap: 6px; align-items: center;">
                            {{ 'funclocDetails.table.serialNumber' | transloco }}
                            <p-sortIcon field="serial_number" />
                        </div>
                    </th>

                    <th pSortableColumn="instrumentName" style="min-width:175px;">
                        <div style="display: flex; gap: 6px; align-items: center;">
                            {{ 'funclocDetails.table.type' | transloco }}
                            <p-sortIcon field="instrumentName" />
                        </div>
                    </th>

                    <th *ngIf="showMachineDataColumns" colspan="4">{{ 'funclocDetails.table.systemHealth' | transloco }}</th>
                    <th *ngIf="showServiceDataColumns" colspan="4">{{ 'funclocDetails.table.serviceHistory' | transloco }}</th>
                    <th *ngIf="showServiceMetricsColumns" colspan="2">{{ 'funclocDetails.table.serviceMetrics' | transloco }}</th>

                </tr>
                <tr>
                    <th pFrozenColumn>
                        <p-columnFilter style="width: 100%" type="text" [showMenu]="false" field="serial_number"
                            matchMode="contains">
                            <ng-template #filter let-value let-filter="filterCallback" style="width: 100%;">
                                <sh-search id="funcloc-details-search-serial-number" no-border [attr.label]="'funclocDetails.filter.serialNumber' | transloco" condensed [(ngModel)]="searchTerm"
                                    (ngModelChange)="filter($event)"></sh-search>
                            </ng-template>
                        </p-columnFilter>
                    </th>
                    <th>
                        <p-columnFilter style="width: 100%" type="text" [showMenu]="false" field="instrumentName"
                            matchMode="contains">
                            <ng-template #filter let-value let-filter="filterCallback" style="width: 100%;">
                                <sh-search id="funcloc-details-search-instrument-name" no-border [attr.label]="'funclocDetails.filter.instrumentName' | transloco" condensed [(ngModel)]="searchTermType"
                                    (ngModelChange)="filter($event)"></sh-search>
                            </ng-template>
                        </p-columnFilter>
                    </th>
                    <th *ngIf="showMachineDataColumns" pSortableColumn="maintenance" style="min-width:125px;">
                        <div style="display: flex; gap: 6px; align-items: center;">
                            {{ 'funclocDetails.table.maintenance' | transloco }}
                            <p-sortIcon field="maintenance" />
                        </div>
                    </th>
                    <th *ngIf="showMachineDataColumns" pSortableColumn="autocheck" style="min-width:125px;">
                        <div style="display: flex; gap: 6px; align-items: center;">
                            {{ 'funclocDetails.table.autocheck' | transloco }}
                            <p-sortIcon field="autocheck" />
                        </div>
                    </th>
                    <th *ngIf="showMachineDataColumns" pSortableColumn="events" style="min-width:125px;">
                        <div style="display: flex; gap: 6px; align-items: center;">
                            {{ 'funclocDetails.table.events' | transloco }}
                            <p-sortIcon field="events" />
                        </div>
                    </th>
                    <th *ngIf="showMachineDataColumns" pSortableColumn="qc" style="min-width:120px;">
                        <div style="display: flex; gap: 6px; align-items: center;">
                            {{ 'funclocDetails.table.qc' | transloco }}
                            <p-sortIcon field="qc" />
                        </div>
                    </th>

                    <th *ngIf="showServiceDataColumns" pSortableColumn="noti" style="min-width:125px;">
                        <div style="display: flex; gap: 6px; align-items: center;">
                            {{ 'funclocDetails.table.openNotis' | transloco }}
                            <p-sortIcon field="noti" />
                        </div>
                    </th>
                    <th *ngIf="showServiceDataColumns" pSortableColumn="parts" style="min-width:125px;">
                        <div style="display: flex; gap: 6px; align-items: center;">
                            {{ 'funclocDetails.table.partsUsed' | transloco }}
                            <p-sortIcon field="parts" />
                        </div>
                    </th>
                    <th *ngIf="showServiceDataColumns" pSortableColumn="visits" style="min-width:125px;">
                        <div style="display: flex; gap: 6px; align-items: center;">
                            {{ 'funclocDetails.table.activities' | transloco }}
                            <p-sortIcon field="visits" />
                        </div>
                    </th>
                    <th *ngIf="showServiceDataColumns" pSortableColumn="proa" style="min-width:125px;">
                        <div style="display: flex; gap: 6px; align-items: center;">
                            {{ 'funclocDetails.table.proactive' | transloco }}
                            <p-sortIcon field="proa" />
                        </div>
                    </th>

                    <th *ngIf="showServiceMetricsColumns" pSortableColumn="cdi" style="min-width:125px;">
                        <div style="display: flex; gap: 6px; align-items: center;">
                            {{ 'funclocDetails.table.cdi' | transloco }}
                            <p-sortIcon field="cdi" />
                        </div>
                    </th>
                    <th *ngIf="showServiceMetricsColumns" pSortableColumn="ci" style="min-width:175px;">
                        <div style="display: flex; gap: 6px; align-items: center;">
                            {{ 'funclocDetails.table.ci' | transloco }}
                            <p-sortIcon field="ci" />
                        </div>
                    </th>
                </tr>
            </ng-template>

            <!-- Body -->
            <ng-template #body let-site>
                <tr>
                    <td pFrozenColumn>
                        <sh-button id="funcloc-details-button-open-link" icon="open-link" icon-position="left"
                            (click)="openWithParams({ material: site['material_number'], serial: site['serial_number'] })"
                            [label]="site.serial_number" color="secondary" size="auto"></sh-button>
                    </td>

                    <td>
                        {{site.instrumentName}}
                    </td>

                    <td *ngIf="showMachineDataColumns">
                        <div style="display: flex; justify-content: flex-end; align-items: center;">
                            <sh-badge id="funcloc-details-badge-true" *ngIf="site.system_health[selectedRange+''].maintenance !== 0" type='warning'
                                size="medium" show-label="true"
                                [label]="site.system_health[selectedRange+''].maintenance+''"></sh-badge>
                            <span *ngIf="site.system_health[selectedRange+''].maintenance === 0">-</span>
                        </div>
                    </td>
                    <td *ngIf="showMachineDataColumns">
                        <div style="display: flex; justify-content: flex-end; align-items: center;">
                            <sh-badge id="funcloc-details-badge-true" *ngIf="site.system_health[selectedRange+''].autochecks !== 0" type='warning'
                                size="medium" show-label="true"
                                [label]="site.system_health[selectedRange+''].autochecks+''"></sh-badge>
                            <span *ngIf="site.system_health[selectedRange+''].autochecks === 0">-</span>
                        </div>
                    </td>
                    <td *ngIf="showMachineDataColumns">
                        <div style="display: flex; justify-content: flex-end; align-items: center;">
                            <sh-badge id="funcloc-details-badge-true" *ngIf="site.system_health[selectedRange+''].error_events !== 0" type='warning'
                                size="medium" show-label="true"
                                style="background-color: var(--success-icon-color) !important"
                                [label]="site.system_health[selectedRange+''].error_events+''"></sh-badge>
                            <span *ngIf="site.system_health[selectedRange+''].error_events === 0">-</span>
                        </div>
                    </td>
                    <td *ngIf="showMachineDataColumns">
                        <div style="display: flex; justify-content: flex-end; align-items: center;">
                            <sh-badge id="funcloc-details-badge-true" *ngIf="site.system_health[selectedRange+''].qc !== 0" type='warning' size="medium"
                                style="background-color: var(--success-icon-color) !important" show-label="true"
                                [label]="site.system_health[selectedRange+''].qc+''"></sh-badge>
                            <span *ngIf="site.system_health[selectedRange+''].qc === 0">-</span>
                        </div>
                    </td>


                    <td *ngIf="showServiceDataColumns">
                        <div style="display: flex; justify-content: flex-end; align-items: center;">
                            <sh-badge id="funcloc-details-badge-true"
                                *ngIf="site.service_history[selectedRange+''].notifications_open !== 0 && !site.totally_down"
                                type='warning' size="medium" show-label="true"
                                [label]="site.service_history[selectedRange+''].notifications_open+''"></sh-badge>
                            <sh-badge id="funcloc-details-badge-true"
                                *ngIf="site.service_history[selectedRange+''].notifications_open !== 0 && site.totally_down"
                                type='error' size="medium" show-label="true"
                                [label]="site.service_history[selectedRange+''].notifications_open+''"></sh-badge>
                            <span *ngIf="site.service_history[selectedRange+''].notifications_open === 0">-</span>
                        </div>
                    </td>
                    <td *ngIf="showServiceDataColumns">
                        <div style="display: flex; justify-content: flex-end; align-items: center;">
                            <sh-badge id="funcloc-details-badge-true" *ngIf="site.service_history[selectedRange+''].spare_parts_used !== 0"
                                size="medium" show-label="true"
                                style="background-color: var(--success-icon-color) !important; color: black"
                                [label]="site.service_history[selectedRange+''].spare_parts_used+''"></sh-badge>
                            <span *ngIf="site.service_history[selectedRange+''].spare_parts_used === 0">-</span>
                        </div>
                    </td>
                    <td *ngIf="showServiceDataColumns">
                        <div style="display: flex; justify-content: flex-end; align-items: center;">
                            <sh-badge id="funcloc-details-badge-true" *ngIf="site.service_history[selectedRange+''].site_visits !== 0" size="medium"
                                show-label="true"
                                style="background-color: var(--success-icon-color) !important; color: black"
                                [label]="site.service_history[selectedRange+''].site_visits+''"></sh-badge>
                            <span *ngIf="site.service_history[selectedRange+''].site_visits === 0">-</span>
                        </div>
                    </td>
                    <td *ngIf="showServiceDataColumns">
                        <div style="display: flex; justify-content: flex-end; align-items: center;">
                            <sh-badge id="funcloc-details-badge-true" *ngIf="site.service_history[selectedRange+''].alarms !== 0" type='warning'
                                size="medium" show-label="true"
                                [label]="site.service_history[selectedRange+''].alarms+''"></sh-badge>
                            <span *ngIf="site.service_history[selectedRange+''].alarms === 0">-</span>
                        </div>
                    </td>

                    <td *ngIf="showServiceMetricsColumns">
                        <div style="display: flex; justify-content: flex-end; align-items: center;">
                            <sh-badge id="funcloc-details-badge-true" *ngIf="site.service_metrics.cdi.current <= site.service_metrics.cdi.benchmark"
                                size="medium" show-label="true" icon-color="black"
                                style="background-color: var(--success-icon-color) !important; color: black"
                                [label]="site.service_metrics.cdi.current+' / '+site.service_metrics.cdi.benchmark"></sh-badge>
                            <sh-badge id="funcloc-details-badge-true" *ngIf="site.service_metrics.cdi.current > site.service_metrics.cdi.benchmark"
                                size="medium" show-label="true" icon-color="black" type="warning"
                                style="background-color: var(--success-icon-color) !important; color: black"
                                [label]="site.service_metrics.cdi.current+' / '+site.service_metrics.cdi.benchmark"></sh-badge>
                        </div>
                    </td>
                    <td *ngIf="showServiceMetricsColumns">
                        <div style="display: flex; justify-content: flex-end; align-items: center;">
                            <sh-badge id="funcloc-details-badge-true" *ngIf="site.service_metrics.ci.current <= site.service_metrics.ci.benchmark"
                                size="medium" show-label="true" icon-color="black" class="mod-badge"
                                style="background-color: var(--success-icon-color) !important; color: black"
                                [label]="site.service_metrics.ci.current+' / '+site.service_metrics.ci.benchmark"></sh-badge>
                            <sh-badge id="funcloc-details-badge-true" *ngIf="site.service_metrics.ci.current > site.service_metrics.ci.benchmark"
                                size="medium" show-label="true" icon-color="black" type="warning" class="mod-badge"
                                style="background-color: var(--success-icon-color) !important; color: black"
                                [label]="site.service_metrics.ci.current+' / '+site.service_metrics.ci.benchmark"></sh-badge>
                        </div>
                    </td>
                </tr>

            </ng-template>


            <ng-template pTemplate="emptymessage">
                <tr>
                    <td colspan="7">
                        <div *ngIf="!isError"
                            style="display: flex; align-items: center; justify-content: center; gap:8px; height: 100%;">
                            <sh-icon id="funcloc-details-icon-warning" icon="warning" size="s"></sh-icon>
                            <span>{{ 'common.empty.noData' | transloco }}</span>
                        </div>
                        <div *ngIf="isError"
                            style="display: flex; align-items: center; justify-content: center; gap:8px; height: 100%;">
                            <sh-icon id="funcloc-details-icon-error" icon="error" size="s"></sh-icon>
                            <span>{{ 'common.empty.error' | transloco }}</span>
                        </div>
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </div>

</div>